// src/theme/index.ts
import { AppColors } from '@/assets/colors';
import { createTheme, responsiveFontSizes, ThemeOptions } from '@mui/material';
import { grey } from '@mui/material/colors';

declare module '@mui/material/styles' {
  interface Theme {
    initialColorMode: string;
    colors: {
      ash?: string;
      primary?: string;
      primaryGray?: string;
      secondary?: string;
      backgroundDark?: string;
      backgroundLight?: string;
      secondaryDark?: string;
      gray?: string;
      black?: string;
      white?: string;
      border?: string;
      tertiary?: string;
      altPaper?: string;
      selected?: string;
      new?: string;
      select?: string;
      placeholder?: string;
      primaryLight?: string;
      primary_overlay?: string;
      secondary_overlay?: string;
      dark_secondary_overlay?: string;
      dark_foot?: string;
      text?: string;
      overlay?: string;
      divider?: string;
      darkPaper?: string;
      subGray?: string;
      lightGray?: string;
      sapphireBlue?: string;
      error?: string;
    };
  }

  interface ThemeOptions {
    initialColorMode?: string;
    colors?: {
      ash?: string;
      primary?: string;
      primaryGray?: string;
      secondary?: string;
      backgroundLight?: string;
      primaryLight?: string;
      primary_overlay?: string;
      secondary_overlay?: string;
      overlay?: string;
      white?: string;
      black?: string;
      text?: string;
      dark_foot?: string;
      dark_secondary_overlay?: string;
      divider?: string;
      gray?: string;
      darkPaper?: string;
      subGray?: string;
      lightGray?: string;
      sapphireBlue?: string;
      error?: string;
    };
  }
}

const theme = (dark: boolean): ThemeOptions =>
  responsiveFontSizes(
    createTheme({
      initialColorMode: dark ? 'dark' : 'light',
      colors: {
        primary: AppColors.primary['300'],
        primaryGray: AppColors.neutral['40'],
        primaryLight: AppColors.primary['200'],
        secondary: AppColors.secondary['300'],
        black: "#000",
        white: "#fff",
        gray: "#bbb",
        subGray: "#D9D9D9",
        lightGray: "#F9FAFB",
        divider: grey['300'],
        darkPaper: grey['900'],
        backgroundLight: dark ? grey['800'] : '#fff',
        primary_overlay: AppColors.primary['200'],
        secondary_overlay: AppColors.secondary['200'],
        dark_secondary_overlay: AppColors.secondary['400'],
        dark_foot: AppColors.primary['500'],
        text: dark ? AppColors.text['light'] : AppColors.text['default'],
        overlay: 'rgba(0, 0, 0, 0.5)',
        sapphireBlue: '#1078BE',
        error: AppColors.error.default,
      },
      palette: {
        mode: dark ? 'dark' : 'light',
        primary: {
          main: AppColors.primary['300'],
          contrastText: AppColors.neutral['100'],
        },
        secondary: {
          main: AppColors.secondary['300'],
          contrastText: AppColors.neutral['90'],
        },
        text: {
          primary: dark ? AppColors.text['light'] : AppColors.text['default'],
          secondary: AppColors.secondary['300'],
        },
        background: {
          paper: dark ? grey['800'] : AppColors.neutral['100'],
          default: dark ? grey['900'] : AppColors.neutral['100'],
        },
        error: {
          main: AppColors.error.default,
        },
      },
      typography: {
        fontFamily: ['"General Sans"', 'Playfair Display', 'sans-serif'].join(','),
        body1: {
          fontSize: '16px',
        },
        body2: {
          fontSize: '12px',
        },
        button: {
          textTransform: 'initial',
          fontSize: '14px',
        },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 900,
          lg: 1200,
          xl: 1536,
        },
      },
      spacing: [0, 4, 8, 16, 32, 64],
    })
  );

export default theme; // Export the theme function